export default {
  baseUrl: 'https://api.dev.digifab.stylem.co.jp',
  downloadUrl: 'https://download.dev.digifab.stylem.co.jp',
  algolia: {
    applicationId: 'H9SYLIBVQ7',
    apiKey: 'e8dd41d1148f760b9aafdc1f83b28d6e',
    indexName: 'dev_fabric'
  }
}
